import {useQuery} from "@tanstack/react-query";
import {fetchPupilsByTargetGroup} from "api/targetGroups/fetchPupilsByTargetGroup";

export function useFetchPupilsByTargetGroup(groupId) {
    const { data, error, isLoading, refetch } = useQuery({
        queryKey: ["targetGroups/level2/pupils", groupId],
        queryFn: () => fetchPupilsByTargetGroup(groupId),
        enabled: !!groupId,
    });

    return {
        group: data?.group || null,
        pupils: data?.pupils || [],
        pupilsError: error,
        pupilsIsLoading: isLoading,
        refetchPupils: refetch,
    };
}
